import { ReactElement } from 'react';
import * as React from 'react';
import dynamic from 'next/dynamic';
import Header from 'shared/components/Header';
import { Footer } from '@zoopla/footer';
import ConsentBanner from 'shared/components/ConsentBanner';
import AdScripts from '../AdScripts';

const GoogleOneTap = dynamic(
    () => import('shared/components/AuthModal/section/GoogleOneTap'),
    {
        ssr: false
    }
);

const MainScript = dynamic(() => import('shared/components/main'), {
    ssr: false
});

/**
 * Default layout used across site, includes web chrome i.e header, footer etc
 */
export const Layout: React.FC = ({ children }) => (
    <>
        <Header />
        <AdScripts />
        <ConsentBanner />
        <MainScript />
        {children}
        <GoogleOneTap />
        <Footer />
    </>
);

/**
 * Default getLayout function used if not defined on the Page component.
 * @see {Layout}
 */
export const getWebChromeLayout = (page: ReactElement): ReactElement => (
    <Layout>{page}</Layout>
);
